import type { TrackReferenceOrPlaceholder } from '@livekit/components-react';

export function isSameTrackRef(a?: TrackReferenceOrPlaceholder, b?: TrackReferenceOrPlaceholder): boolean {
    if (!a || !b) return false;
    return a.participant.identity === b.participant.identity && a.source === b.source;
}
